// extracted by mini-css-extract-plugin
export default {"fleet":"Service_fleet__3ere3","fleet__item":"Service_fleet__item__e5uk3","fleet__card":"Service_fleet__card__bIvm-","fleet__card__content":"Service_fleet__card__content__3oVtE"};